export default "__VITE_ASSET__0Yi0qYfw__"